import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	errorServer: false,
	isOpenMenu: false,
    isOpenCloseSesionModal: false
};

export const isUiSlice = createSlice({
	name: "ui",
	initialState,
	reducers: {
		setErrorServer: (state, { payload }) => {
			state.errorServer = payload.value;
		},
		setIsOpenMenu: (state, { payload }) => {
			state.isOpenMenu = payload;
		},
        setIsOpenCloseSesionModal: (state, { payload }) => {
            state.isOpenCloseSesionModal = payload;
        },
	},
});

export const { setErrorServer, setIsOpenMenu, setActiveTesting, setIsOpenCloseSesionModal } = isUiSlice.actions;
